import { useState } from 'react';

import handleCancellationClick from '@/utils/functions/handleCancellationClick/handleCancellationClick';

import useCancelModal from './useCancelModal';

type SelectedContract = {
  nomProduit: string;
  placementId: string;
  famille: string | null | undefined;
  cancelablePeriod: number | null | undefined;
};

type ContractInput = {
  nomProduit?: string | null;
  placementId?: string | null;
  gestionnaire?: string | null;
  famille?: string | null;
  cancelablePeriod?: number | null;
  isCancelable?: boolean | null;
};

const useCancellationHandler = () => {
  const { showCancelModal, openCancelModal, closeCancelModal } = useCancelModal();
  const [selectedContract, setSelectedContract] = useState<SelectedContract | null>(null);

  const getCancellationHandler = (contract: ContractInput) => {
    if (!contract.isCancelable) return undefined;
    return () =>
      handleCancellationClick(contract.gestionnaire, () => {
        setSelectedContract({
          nomProduit: contract.nomProduit ?? '',
          placementId: contract.placementId ?? '',
          famille: contract.famille,
          cancelablePeriod: contract.cancelablePeriod,
        });
        openCancelModal();
      });
  };

  const handleCloseCancelModal = () => {
    closeCancelModal();
    setSelectedContract(null);
  };

  return { showCancelModal, selectedContract, getCancellationHandler, handleCloseCancelModal };
};

export default useCancellationHandler;
